import {Box, Button, IconButton, Link, Typography} from "@material-ui/core";
import Icon from "@mdi/react";
import {
    mdiFacebook as FacebookIcon,
    mdiLinkedin as LinkedinIcon,
    mdiTwitter as TwitterIcon,
    mdiXing as XingIcon
} from "@mdi/js";
import React from "react";
import useStyles from "../../components/Footer/styles";

export const Footer = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.footer}>
            <Box
                className={classes.footerContainer}
                width={"100%"}
                display={"flex"}
                alignItems={"center"}
                justifyContent="space-between"
            >
                <div>
                    <Typography>
                        <Button className={classes.footerButtons} href="https://jobninja.com/" component={Link}>
                            Jobbörse
                        </Button>
                        <Button className={classes.footerButtons} href="https://jobninja.com/impressum" component={Link}>
                            Impressum
                        </Button>
                        <Button className={classes.footerButtons} href="https://jobninja.com/ds.pdf" component={Link}>
                            Datenschutz
                        </Button>
                    </Typography>

                </div>
                <div>
                    <Link
                        href={'https://de.linkedin.com/company/jobninja'}
                        target={'_blank'}
                    >
                        <IconButton aria-label="linkedin">
                            <Icon
                                path={LinkedinIcon}
                                size={1}
                                color="#6E6E6E99"
                            />
                        </IconButton>
                    </Link>
                    <Link
                        href={'https://www.xing.com/pages/jobninja/'}
                        target={'_blank'}
                    >
                        <IconButton aria-label="xing">
                            <Icon
                                path={XingIcon}
                                size={1}
                                color="#6E6E6E99"
                            />
                        </IconButton>
                    </Link>
                    <Link
                        href={'https://de-de.facebook.com/JobNinja.eu'}
                        target={'_blank'}
                    >
                        <IconButton aria-label="facebook">
                            <Icon
                                path={FacebookIcon}
                                size={1}
                                color="#6E6E6E99"
                            />
                        </IconButton>
                    </Link>
                    <Link
                        href={'https://twitter.com/JobNinjaEU'}
                        target={'_blank'}
                    >
                        <IconButton aria-label="twitter">
                            <Icon
                                path={TwitterIcon}
                                size={1}
                                color="#6E6E6E99"
                            />
                        </IconButton>
                    </Link>
                </div>
            </Box>
        </div>
    )
}
